import { withAuthRecovery } from '@/lib/authRecovery'
import { getSupabase } from '@/lib/supabase'

export interface ManagementDashboardNetworkKpis {
  clientSnapshotDate: string | null
  clientBaselineDate: string | null
  clientTotal: number | null
  clientDelta28d: number | null
  qualityReviewsCount: number | null
  qualityAveragePercent: number | null
  royaltyMonth: string | null
  royaltyPlanVersion: number | null
  royaltyPlanRub: number | null
  royaltyChargedRub: number | null
  royaltyPaidRub: number | null
  royaltyDebtRub: number | null
  royaltyCollectionRatePercent: number | null
  royaltyExpectedTotalRub: number | null
  royaltyExpectedRemainingRub: number | null
  calculatedAt: string | null
}

function nullableNumber(value: unknown): number | null {
  if (value == null) return null
  const numberValue = Number(value)
  return Number.isFinite(numberValue) ? numberValue : null
}

function nullableString(value: unknown): string | null {
  return value == null ? null : String(value)
}

export async function getManagementDashboardNetworkKpis(
  periodId: number,
  weekNumber: number | null
): Promise<ManagementDashboardNetworkKpis> {
  const supabase = getSupabase()
  const { data, error } = await withAuthRecovery(() =>
    (supabase as any).rpc('get_management_dashboard_network_kpis', {
      p_period_id: periodId,
      p_week_number: weekNumber,
    })
  )

  if (error) throw error

  const row = ((data ?? []) as Array<Record<string, unknown>>)[0]
  if (!row) throw new Error('Пустой ответ расчёта показателей сети')

  return {
    clientSnapshotDate: nullableString(row.client_snapshot_date),
    clientBaselineDate: nullableString(row.client_baseline_date),
    clientTotal: nullableNumber(row.client_total),
    clientDelta28d: nullableNumber(row.client_delta_28d),
    qualityReviewsCount: nullableNumber(row.quality_reviews_count),
    qualityAveragePercent: nullableNumber(row.quality_average_percent),
    royaltyMonth: nullableString(row.royalty_month),
    royaltyPlanVersion: nullableNumber(row.royalty_plan_version),
    royaltyPlanRub: nullableNumber(row.royalty_plan_rub),
    royaltyChargedRub: nullableNumber(row.royalty_charged_rub),
    royaltyPaidRub: nullableNumber(row.royalty_paid_rub),
    royaltyDebtRub: nullableNumber(row.royalty_debt_rub),
    royaltyCollectionRatePercent: nullableNumber(row.royalty_collection_rate_percent),
    royaltyExpectedTotalRub: nullableNumber(row.royalty_expected_total_rub),
    royaltyExpectedRemainingRub: nullableNumber(row.royalty_expected_remaining_rub),
    calculatedAt: nullableString(row.calculated_at),
  }
}
